
import InvitationsScreen from './InvitationsScreen';

export const PainpointInvitationsScreen = (props: any) => (
  <InvitationsScreen {...props} sessionType="painpoint_session" />
);

export default PainpointInvitationsScreen;
